import { render, staticRenderFns } from "./Navgation.vue?vue&type=template&id=74354573&scoped=true"
import script from "./Navgation.vue?vue&type=script&lang=js"
export * from "./Navgation.vue?vue&type=script&lang=js"
import style0 from "./Navgation.vue?vue&type=style&index=0&id=74354573&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74354573",
  null
  
)

export default component.exports